import { combineReducers } from "redux";

import app from "./app/appReducers";

// Only the `appData` slice remains after the redesign — the `blog` slice
// and its actions/reducers were removed along with the legacy blog pages.
export default combineReducers({
    appData: app,
});
